module.exports = __webpack_public_path__ + "static/media/image-12.5c7ebb9f.jpg";